const $carouselSection = $(".js-integrations-carousel--non-interactive"),
  $carousel = $(".integrations-carousel", $carouselSection),
  $carouselContainer = $(".integrations-carousel__container", $carousel),
  CAROUSEL_CSS_INTERACTIVE_CLASS = "integrations-carousel--interactive",
  CAROUSEL_CONTAINER_CSS_NON_INTERACTIVE_CLASS =
    "integrations-carousel__container--non-interactive";
if ($carouselSection.length) {
  const $links = $("a", $carousel);

  $carousel.removeClass(CAROUSEL_CSS_INTERACTIVE_CLASS);
  $carouselContainer.addClass(CAROUSEL_CONTAINER_CSS_NON_INTERACTIVE_CLASS);

  $links.each((index, link) => {
    $(link)
      .removeAttr("href")
      .css("cursor", "default");
  });
}
